
import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import axios from "axios";
import { extractErrorMessage } from "../util";
import { JobData } from "../types";
import Cookies from "js-cookie";

axios.defaults.withCredentials = true;

const base_url = process.env.REACT_APP_BASE_URL;
//token
const headerToken = Cookies.get("token");

interface AuthState {
  error?: string | null;
  isLoading: boolean;
  singleJob: any;
  questionCategory: any;
  questions: any;
  applicants: {
    data: Array<{
      id: number;
      resume_url: string;
      applied_date: Date;
      status: string;
      job_id: number;
      company_id: number;
      user_id: number;
      created_at: Date;
      updated_at: Date;
      totalMark: number;
      first_name: string;
      last_name: string;
      email: string;
    }>;
    total: number;
  } | null;
  experience: [] | any;
  education: [] | any;
  allSkills: [] | any;
  singleApplicant: any;
  questionAnswer: [] | any;
}

const initialState: AuthState = {
  error: null,
  isLoading: false,
  applicants: null,
  singleJob: null,
  questionCategory: null,
  questions: null,
  experience: [],
  education: [],
  allSkills: [],
  singleApplicant: null,
  questionAnswer: [],
};
interface GetUserQuestionAndAnswer {
  applicant_id: number;
  job_id: number | undefined;
}

export const getUserQuestionAndAnswer = createAsyncThunk(
  "api/getQuestionAndAnswer",
  async ({applicant_id, job_id}: GetUserQuestionAndAnswer, thunkAPI) => {
    try {
      const response = await axios.get(
        `${base_url}/jobQuestionAnswersAdmin/${applicant_id}/${job_id}`,
        {
          withCredentials: true,
          headers: {
            Authorization: `Bearer ${headerToken}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(extractErrorMessage(error));
    }
  }
);

export const getApplicants = createAsyncThunk(
  "api/getApplicants",
  async (job_id: number, thunkAPI) => {
    try {
      const response = await axios.get(
        `${base_url}/getJobApplications/${job_id}`,
        {
          withCredentials: true,
          headers: {
            Authorization: `Bearer ${headerToken}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(extractErrorMessage(error));
    }
  }
);

export const getWork = createAsyncThunk(
  "api/getWork",
  async (id: any, thunkAPI) => {
    try {
      const response = await axios.get(`${base_url}/getUserExperience/${id}`, {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${headerToken}`,
        },
      });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(extractErrorMessage(error));
    }
  }
);

export const getEdu = createAsyncThunk(
  "api/getEdu",
  async (id: any, thunkAPI) => {
    try {
      const response = await axios.get(`${base_url}/getUserEducation/${id}`, {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${headerToken}`,
        },
      });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(extractErrorMessage(error));
    }
  }
);

export const getSkills = createAsyncThunk(
  "api/getSkills",
  async (id:number, thunkAPI) => {
    try {
      const response = await axios.get(`${base_url}/getUserSkills/${id}`, {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${headerToken}`,
        },
      });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(extractErrorMessage(error));
    }
  }
);

export const getUserById = createAsyncThunk(
  "api/getUserById",
  async (id: number, thunkAPI) => {
    try {
      const response = await axios.get(`${base_url}/user/${id}`, {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${headerToken}`,
        },
      });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(extractErrorMessage(error));
    }
  }
);

// Redux slice for authentication
const applicantSlice = createSlice({
  name: "applicant",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getApplicants.fulfilled, (state, action) => {
      state.applicants = action.payload;
      state.isLoading = false;
    })
 .addCase(getWork.fulfilled, (state, action) => {
      state.experience = action.payload;
      state.isLoading = false;
    })
      .addCase(getEdu.fulfilled, (state, action) => {
        state.education = action.payload;
        state.isLoading = false;
      })
      .addCase(getSkills.fulfilled, (state, action) => {
        state.allSkills = action.payload;
        state.isLoading = false;
      })
      .addCase(getUserById.fulfilled, (state, action) => {
        state.singleApplicant = action.payload;
        state.isLoading = false;
      })
      .addCase(getUserQuestionAndAnswer.fulfilled, (state, action) => {
        state.questionAnswer = action.payload;
        state.isLoading = false;
    })
    }
      
});

export default applicantSlice.reducer;
